!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.instanceId = this.generateUniqueId(), this.form = this.querySelector("form"), 
      this.emailInput = this.querySelector('input[name="email"]'), this.idInput = this.querySelector("[data-id]"), 
      this.radios = this.querySelectorAll("[data-option-radio]"), this.submit = this.querySelector("[data-submit]"), 
      this.submitText = this.querySelector("[data-submit-text]"), this.marketingCheckbox = this.querySelector('input[name="accepts_marketing"]'), 
      this.variants = JSON.parse(this.querySelector("[data-product-variants]").textContent), 
      this.handleSubmit = this.handleSubmit.bind(this), this.handleSubmitClick = this.handleSubmitClick.bind(this), 
      this.handleVariantChange = this.handleVariantChange.bind(this), this.handleProductFormVariantChange = this.handleProductFormVariantChange.bind(this), 
      this.handleProductFormSync = this.handleProductFormSync.bind(this), this.handleProductCardVariantSelection = this.handleProductCardVariantSelection.bind(this);
    }
    connectedCallback() {
      this.makeInputIdsUnique(), this.form.addEventListener("submit", this.handleSubmit), 
      this.submit.addEventListener("click", this.handleSubmitClick), this.radios.forEach(t => t.addEventListener("change", this.handleVariantChange)), 
      document.addEventListener("product-form:variant-changed", this.handleProductFormVariantChange), 
      document.addEventListener("product-form:sync-to-modal", this.handleProductFormSync), 
      document.addEventListener("product-card:show-out-of-stock-modal", this.handleProductCardVariantSelection), 
      this.updateOptionAvailability(), this.handleVariantChange();
    }
    handleProductCardVariantSelection(t) {
      if (t.detail.productId !== this.dataset.productId) return;
      const e = t.detail.variantId, i = this.variants.find(t => t.id === e);
      i && (i.options.forEach((t, e) => {
        const i = this.querySelector(`input[name="option${e + 1}"][value="${t}"]`);
        i && (i.checked = !0);
      }), this.idInput.value = e, this.handleVariantChange());
    }
    generateUniqueId() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }
    makeInputIdsUnique() {
      const t = this.querySelectorAll('input[type="radio"]');
      this.querySelectorAll("label[for]");
      t.forEach(t => {
        const e = t.id, i = `${e}-${this.instanceId}`;
        t.id = i;
        const s = this.querySelector(`label[for="${e}"]`);
        s && s.setAttribute("for", i);
      });
      const e = this.querySelector('input[name="accepts_marketing"]'), i = this.querySelector('label[for="accepts-marketing"]');
      if (e && i) {
        const t = `accepts-marketing-${this.instanceId}`;
        e.id = t, i.setAttribute("for", t);
      }
    }
    updateOptionAvailability(t = this.getSelectedOptions()) {
      this.radios.forEach(e => {
        const i = +e.name.replace("option", "") - 1, s = this.variants.some(s => s.available && s.options[i] === e.value && s.options.every((e, s) => s === i || !t[s] || t[s] === e));
        e.toggleAttribute("aria-out-of-stock", !s);
      });
    }
    getSelectedOptions(t) {
      return [ ...new Set([ ...this.radios ].map(t => t.name)) ].map(e => {
        if (t?.name === e) return t.value;
        const i = this.querySelector(`input[name="${e}"]:checked`);
        return i?.value || null;
      });
    }
    findMatchingVariant(t) {
      return this.variants.find(e => e.options.every((e, i) => e === t[i]));
    }
    updateOptionLabels(t) {
      [ ...new Set([ ...this.radios ].map(t => t.name)) ].forEach(e => {
        const i = +e.replace("option", "") - 1, s = t[i];
        if (!s) return;
        const a = this.querySelector(`input[name="${e}"]`)?.closest(".flex.flex-col.gap-3"), n = a?.querySelector("[data-option-label]");
        if (n) {
          const t = n.dataset.optionName || n.textContent.split(":")[0];
          n.textContent = `${t}: ${s}`;
        }
      });
    }
    toggleEmailInputs(t) {
      this.emailInput && (this.emailInput.disabled = t), this.marketingCheckbox && (this.marketingCheckbox.disabled = t);
    }
    handleVariantChange(t) {
      const e = this.getSelectedOptions(), i = this.findMatchingVariant(e);
      i ? this.applyVariantUpdates(i) : this.hasSingleVariantWithNoOptions() ? this.applyVariantUpdates(this.variants[0]) : this.resetForm(), 
      this.updateOptionLabels(e), this.updateOptionAvailability(e), t && this.dispatchVariantChangedEvent(e, i);
    }
    hasSingleVariantWithNoOptions() {
      return 1 === this.variants.length && 0 === this.radios.length;
    }
    resetForm() {
      this.idInput.value = "", this.submit.disabled = !0, this.submitText.textContent = window.strings?.selectOptions || "Select options", 
      this.toggleEmailInputs(!1);
    }
    applyVariantUpdates(t) {
      this.idInput.value = t.id;
      const e = t.available;
      this.submit.disabled = !1, this.submitText.textContent = e ? window.strings?.inStock || "In stock" : window.strings?.outOfStock?.notify || "Notify me", 
      this.toggleEmailInputs(e);
    }
    dispatchVariantChangedEvent(t, e) {
      document.dispatchEvent(new CustomEvent("out-of-stock-modal:variant-changed", {
        detail: {
          selectedOptions: t,
          matchingVariant: e,
          productId: this.dataset.productId
        }
      }));
    }
    handleProductFormVariantChange(t) {
      if (t.detail.productId !== this.dataset.productId) return;
      const e = this.closest("details");
      e?.open && this.syncFromProductForm(t.detail);
    }
    handleProductFormSync(t) {
      t.detail.productId === this.dataset.productId && this.syncFromProductForm(t.detail);
    }
    syncFromProductForm({selectedOptions: t}) {
      t.forEach((t, e) => {
        if (t) {
          const i = this.querySelector(`input[name="option${e + 1}"][value="${t}"]`);
          i && !i.checked && (i.checked = !0);
        }
      }), this.handleVariantChange();
    }
    handleSubmitClick(t) {
      const e = this.idInput.value;
      if (!e) return;
      const i = this.variants.find(t => t.id === +e);
      if (!i) return t.preventDefault(), void alert("Invalid variant selected.");
      if (i.available) {
        t.preventDefault();
        const i = this.dataset.productHandle;
        if (!i) return;
        const s = window.location.pathname, a = `/products/${i}`;
        if (s === a || s === `${a}/`) if (window.TeleportDetails?.closeFromTeleportedContent) window.TeleportDetails.closeFromTeleportedContent(this); else {
          const t = this.closest("[data-modal]"), e = t?.querySelector("[data-close]");
          e && e.click();
        } else {
          const t = `/products/${i}?variant=${e}`;
          window.location.href = t;
        }
      }
    }
    handleSubmit(t) {
      t.preventDefault();
      const e = this.idInput.value, i = this.variants.find(t => t.id === +e);
      if (!e || !i) return void this.showError(e ? "Invalid variant selected." : "Please select a variant.");
      const s = this.emailInput.value;
      if (!s) return void this.showError("Please enter your email address.");
      if (this.clearError(), this.setSubmitLoadingState(), void 0 === window.BIS || !window.BIS || "function" != typeof window.BIS.create) return console.warn("BIS (Back in Stock) API is not available yet"), 
      this.setSubmitTemptState(window.strings?.error || "Error"), void this.showError("Service temporarily unavailable. Please try again in a moment.");
      const a = this.marketingCheckbox?.checked ? {
        accepts_marketing: !0
      } : {};
      BIS.create(s, e, this.dataset.productId, a).then(t => {
        "OK" === t.status ? this.handleSuccess(t.message) : this.handleError(t.errors);
      });
    }
    setSubmitLoadingState() {
      this.setButtonState(!0, window.strings?.adding || "Submitting...");
    }
    setSubmitTemptState(t) {
      this.setButtonState(!1, t), setTimeout(() => this.restorePreviousButtonText(), 1e3);
    }
    setButtonState(t, e) {
      this.submit.disabled = t, this.submitText.dataset.previousText || (this.submitText.dataset.previousText = this.submitText.innerHTML), 
      this.submitText.innerHTML = e;
    }
    restorePreviousButtonText() {
      const t = this.submitText.dataset.previousText;
      t && (this.submitText.innerHTML = t, delete this.submitText.dataset.previousText);
    }
    handleSuccess(t) {
      if (this.restorePreviousButtonText(), this.submit.disabled = !1, this.showToast(t, "success"), 
      window.TeleportDetails?.closeFromTeleportedContent) window.TeleportDetails.closeFromTeleportedContent(this); else {
        const t = this.closest("[data-modal]"), e = t?.querySelector("[data-close]");
        e && e.click();
      }
    }
    handleError(t) {
      this.setSubmitTemptState(window.strings?.error || "Error");
      let e = "";
      if ("object" == typeof t) for (const [, i] of Object.entries(t)) e += (Array.isArray(i) ? i.join(", ") : i) + " "; else e = t.toString();
      this.showError(e.trim());
    }
    showError(t) {
      this.clearError();
      const e = document.createElement("div");
      e.className = "text-sm text-red-600 mt-2", e.setAttribute("data-error-message", ""), 
      e.textContent = t, this.form.appendChild(e);
    }
    clearError() {
      this.form.querySelector("[data-error-message]")?.remove();
    }
    showToast(t, e = "success") {
      const i = Shopify.MBF.settings || {}, s = i[`toast_${e}_color`] || i.toast_popup_color || i.wishlist_popup_color || "", a = 1e3 * (i.toast_popup_duration || i.wishlist_popup_duration || 3), n = `outOfStock${e.charAt(0).toUpperCase() + e.slice(1)}Toast-${Date.now()}`, o = `\n      <pop-up class="px-offset py-5 bg-scheme-contrast w-grid [--columns:4] [--offsets:0] [--spacing-gutter:var(--spacing-gutter-sm)] fixed top-[var(--combined-header-height,_92px)] right-0 tablet:top-auto tablet:right-auto tablet:[--columns:1] tablet:bottom-mobile-nav opacity-100 pointer-events-auto z-[999] ${s ? `color-${s}` : ""}" data-name="${n}">\n        <div class="flex flex-col justify-between gap-3">\n          <div class="flex justify-between gap-2.5">\n            <div class="text-md text-scheme-links">${t}</div>\n            <div class="shrink-0" data-close>\n              <svg class="text-scheme-icons cursor-pointer" width="18" height="18" viewBox="0 0 18 18" fill="none">\n                <path d="M14 4 4 14M4 4l10 10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"/>\n              </svg>\n            </div>\n          </div>\n        </div>\n      </pop-up>\n    `;
      document.body.insertAdjacentHTML("beforeend", o);
      const r = document.querySelector(`pop-up[data-name="${n}"]`);
      r.querySelector("[data-close]")?.addEventListener("click", () => r.remove()), setTimeout(() => r?.parentNode && r.remove(), a);
    }
  }
  customElements.get("out-of-stock-form") || customElements.define("out-of-stock-form", t);
}();